import { ScreenOrientation } from '@gongxigames/framework/core/types';

export type AppViewportConfig = {
    forceOrientation?: ScreenOrientation;
    safeZone: PlatformSafeZones;
};

export type SafeZoneSize = {
    readonly width: number;
    readonly height: number;
};

export type PlatformSafeZones = {
    [ScreenOrientation.LANDSCAPE]: SafeZoneSize;
    [ScreenOrientation.PORTRAIT]?: SafeZoneSize;
};
